import { createFileRoute } from '@tanstack/react-router';

import { WinbackOfferSetupComplete } from 'src/apps/checkout/app/pages/WinbackOffer.SetupComplete';

export const Route = createFileRoute(
  '/_auth/_only-header/store/methods-offer/setup-complete'
)({
  component: () => <WinbackOfferSetupComplete />,
});
